export default "__VITE_ASSET__Clfe2voA__"